import { render, staticRenderFns } from "./WrongQuestionAnswerFree.vue?vue&type=template&id=0db8aafa&scoped=true&"
import script from "./WrongQuestionAnswerFree.vue?vue&type=script&lang=ts&"
export * from "./WrongQuestionAnswerFree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8aafa",
  null
  
)

export default component.exports